<template>
  <section class="tramite">
    <h3 class="title text-center">{{ $t('tramite.title') }}</h3>
    <div class="form-group">
      <label>{{ $t('BUSCAR_TRAMITE') }}</label>
      <input
        type="search"
        class="form-control"
        v-model="search"
        v-bind:placeholder="$t('ESCRIBIR_TRAMITE')">
    </div>
    <div class="grid cols-2">
      <div v-for="(items, key) in documentosFilter" :key="`d${key}`">
        <h4 class="title">{{ key }}</h4>
        <ul>
          <li v-for="item in items" :key="`k${item.id}`">
            <p>{{ item.nombre }}<br>
            <small><em>{{ item.descripcion }}</em></small><br>
            <small><strong>Nota: </strong></small>
            <small v-if="item.clasificacion === 'EMITIDO_TERCEROS'"><em>Todo trámite emitido por terceros necesita del documento adjunto, que posteriormente debe ser presentado físicamente en oficinas del MINEDU.</em></small>
            <small v-if="item.clasificacion === 'EMITIDO_MINEDU' && !item.gestion_fin"><em>Este trámite no requiere del documento adjunto, es totalmente digital.</em></small>
            <small v-if="item.clasificacion === 'EMITIDO_MINEDU' && item.gestion_fin"><em>Este trámite requiere el documento adjunto, si el mismo fue emitido hasta la gestión {{ item.gestion_fin }}.</em></small>
            <br>
            <span class="links">
              <strong>{{ $t('PRECIO') }} {{ item.precio }} Bs.</strong> |
              <router-link to="/solicitud" v-if="item.clasificacion === 'EMITIDO_MINEDU'">{{ $t('SOLICITAR_LEGALIZACION') }}</router-link>
              <router-link to="/solicitud" v-if="item.clasificacion === 'EMITIDO_TERCEROS'">{{ $t('SOLICITAR_CERTIFICACION') }}</router-link>
            </span>
            <br>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Documentos from '@/components/pages/mixins/documentos';

export default {
  mixins: [ Documentos ],
  mounted () {
    this.getDocumentos(true);
  },
  data () {
    return {
      documentos: [],
      search: ''
    };
  },
  computed: {
    documentosFilter () {
      let documentos = {};
      for (let key in this.documentos) {
        let items = this.documentos[key].filter(item => {
          return item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                 item.entidad_nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });

        if (items.length) {
          documentos[key] = items;
        }
      }
      return documentos;
    }
  }
};
</script>

<style lang="scss">
.links {
  font-size: 0.8rem;
  margin-bottom: 15px;

  a {
    font-size: 0.8rem;
  }
}
@media (max-width: 768px) {
  .tramite .grid {
    h4 {
      margin: 25px 0 10px;
      text-align: center;
    }
    ul {
      margin: 0;
      padding: 0 15px;
    }
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Tramite.vue